<template>

  <div id="page-user-list">
    <!-- <data-view-sidebar :isSidebarActive="addNewDataSidebarAddClientPDN" @closeSidebar="toggleDataSidebarAddClientPDN" :data="sidebarDataAddClientPDN" v-on:closeSidebarSuccess="updateListClientsPDN"/> -->
    <vs-prompt
      @cancel="initValues"
      @accept="submitData"
      title="Agregar Nuevo Cliente"
      acceptText= "Crear"
      cancelText= "Cancelar"
      :is-valid="isFormValid"
      :active.sync="activePrompt">
      <VuePerfectScrollbar :settings="{ maxScrollbarLength: 60,  wheelSpeed: .60 }">
        <div class="con-exemple-prompt pb-24">
          <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Nombres (requerido)" v-model="names_client" class="w-full" name="names_client" v-validate="'alpha_spaces'" />
                  <span class="text-danger text-sm" v-show="errors.has('names_client')">{{ errors.first('names_client') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Apellidos (requerido)" v-model="surnames_client" class="w-full" name="surnames_client" v-validate="'alpha_spaces'" />
                  <span class="text-danger text-sm" v-show="errors.has('surnames_client')">{{ errors.first('surnames_client') }}</span>
              </div>
          </div>
          <div class="vx-row">
              <div class="vx-col w-full">
                  <vs-input label="Email (requerido)" v-model="email" class="w-full" name="email" v-validate="'required|email'" />
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
          </div>
          <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Contraseña (requerido)" placeholder="" v-model="password" class="w-full" name="password" v-validate="'required|min:8|max:15'" ref="password"/>
                  <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Repetir contraseña (req.)" placeholder="" v-model="password_confirmation" class="w-full" name="password_confirmation" v-validate="'min:8|max:15|confirmed:password'" data-vv-as="password" />
                  <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
              </div>
          </div>
          <div class="vx-row">
            <hr>
          </div>
          <!-- TELEFONOS -->
          <div class="vx-row px-4">
            <div class="w-full">
                <vs-input label="Telf Móvil (opcional)" v-model="phone_mobile_client" placeholder="0584166889887" class="w-full" name="phone_mobile_client" />
                <span class="text-danger text-sm" v-show="errors.has('phone_mobile_client')">{{ errors.first('phone_mobile_client') }}</span>
            </div>
          </div>
          <!-- PAIS  -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <label class="vs-input--label">País de procedencia <small>(donde se encuentra ahora mismo)</small></label>
              <v-select :closeOnSelect="true" v-model="id_country" label="name_country" :options="countries" name="id_country" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
          </div>

          <!-- 1RA NACIONALIDAD  Y 2DA NACIONALIDAD-->
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">1ra Nacionalidad</label>
              <v-select :closeOnSelect="true" v-model="id_first_nationality" label="name_country" :options="countries" name="id_first_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">2da Nacionalidad</label>
              <v-select :closeOnSelect="true" v-model="id_second_nationality" label="name_country" :options="countries" name="id_second_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </vs-prompt>

    <div class="flex flex-wrap items-rigth">
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="openCloseModal()">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Agregar Nuevo Cliente</span>
      </div>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">

        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(200)">
                <span>200</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
                <span>500</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(1000)">
                <span>1000</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />

        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Acciones</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu class="ancho-dropdown">
            <vs-dropdown-item>
              <span title="Descargar Todo" class="flex items-center" @click.stop="exportarCsvAll()">
                <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Todo CSV</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <span title="Descargar Seleccionados" class="flex items-center" @click.stop="exportarCsvSelected()">
                <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Seleccionados CSV</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <span class="flex items-center" v-on:click="sizeToFit()">
                <feather-icon icon="Minimize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Ancho ajustado</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <span class="flex items-center" v-on:click="autoSizeAll()">
                <feather-icon icon="Maximize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Ancho Automático</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault=""
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @column-resized="onColumnResized">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererWelcomeEmail from './cell-renderer/CellRendererWelcomeEmail.vue'
import CellRendererRoles from './cell-renderer/CellRendererRoles.vue'
import CellRendererActionsEXT from './cell-renderer/CellRendererActionsEXT.vue'
import CellRendererProgressVisaSteps from './cell-renderer/CellRendererProgressVisaSteps.vue'
import CellRendererContract from './cell-renderer/CellRendererContract.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererWelcomeEmail,
    CellRendererRoles,
    CellRendererActionsEXT,
    CellRendererProgressVisaSteps,
    CellRendererContract
  },
  data () {
    return {
      // Data Sidebar
      addNewDataSidebarAddClientPDN: false,
      sidebarDataAddClientPDN: {},
      searchQuery: '',
      
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true, 
        editable: false
      },
      columnDefs: [
        {
          headerName: 'Opciones',
          field: 'transactions',
          width: 70,
          cellClass: 'cell-items-center',
          pinned: 'left',
          cellRendererFramework: 'CellRendererActionsEXT'
        },
        {
          headerName: 'Cliente',
          field: 'full_name_client',
          filter: true,
          width: 180,
          pinned: 'left',
          cellRendererFramework: 'CellRendererLink',
          // getQuickFilterText: params => {
          //   return `${params.data.names_client} ${params.data.surnames_client}`
          // },
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: 'Email',
          field: 'email_client',
          filter: true,
          width: 200
        },
        {
          headerName: 'Correo enviado',
          field: 'welcomeEmail',
          filter: true,
          width: 140,
          cellRendererFramework: 'CellRendererWelcomeEmail'
        },
        {
          headerName: 'Asesor',
          field: 'assignedAdvisor.full_name_employee',
          filter: true,
          width: 100,
          cellClass: 'cell-wrap-text'
        },
        {
          headerName: 'Visado',
          field: 'name_visa_type',
          filter: true,
          width: 200,
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: 'Servicio Contratado',
          field: 'name_service',
          filter: true,
          width: 280,
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: 'Progreso',
          field: 'visaSteps',
          filter: false,
          cellRendererFramework: 'CellRendererProgressVisaSteps',
          width: 200
        },
        {
          headerName: 'Último paso completado',
          field: 'visaSteps',
          filter: true,
          valueFormatter (params) {
            const lastItem = params.data.visaSteps.filter(item => item.number_advisor_visa_step !== null && item.status_visa_step === 'Completado').length
            return (params.data.visaSteps.filter(item => item.number_advisor_visa_step !== null && item.status_visa_step === 'Completado').length > 0) ? (params.data.visaSteps.filter(item => item.number_advisor_visa_step !== null && item.status_visa_step === 'Completado')[lastItem - 1].name_visa_step) : '' 
          },
          width: 200,
          cellClass: 'cell-wrap-text',
          autoHeight: true
        }
      ],

      email: null,
      password: null,
      password_confirmation: null,
      names_client: null,
      surnames_client: null,
      phone_mobile_client: null,
      id_country: 1,
      id_first_nationality: 1,
      id_second_nationality: 1,
      activePrompt: false,

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererWelcomeEmail,
        CellRendererRoles,
        CellRendererActionsEXT,
        CellRendererProgressVisaSteps,
        CellRendererContract
        // CellRendererComments
      }
    }
  },
  computed: {
    usersData () {
      const usersData = this.$store.state.clientsInmigration
      return usersData.sort((a, b) => b.id_client - a.id_client)
    },
    countries () {
      return this.$store.state.countries
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    openCloseModal () {
      this.initValues()
      this.activePrompt = !this.activePrompt
    },
    initValues () {
      this.email = null
      this.password = null
      this.password_confirmation = null
      this.names_client = null
      this.surnames_client = null
      this.phone_mobile_client = null
      this.id_country = 1
      this.id_first_nationality = 1
      this.id_second_nationality = 1
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation
          }
          const obj2 = {
            names: this.names_client,
            surnames: this.surnames_client,
            first_nationality_id: this.id_first_nationality,
            second_nationality_id: this.id_second_nationality,
            phone_mobile: this.phone_mobile_client,
            country_id: this.id_country
          }
          this.$vs.loading()
          this.$store.dispatch('addItemClientPDN', obj)
            .then((res) => {
              this.$vs.notify({
                title: 'Cliente creado',
                text: 'Ha sido registrado un nuevo cliente',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              })
              const obj3 = {
                id_client: res.data.client_id
              }
              const mergedObj = {
                ...obj2,
                ...obj3
              }
              this.$store.dispatch('updateClientPerfil', mergedObj)
                .then(() => { this.$vs.loading.close() })
                .then(() => {
                  this.$vs.notify({
                    title: 'Datos cliente actualizados',
                    text: 'Ha sido actualizado un cliente',
                    color: 'success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    time: 4000
                  })
                  this.updateListClientsPDN()
                  alert('Añade un servicio de extranjeria para el nuevo cliente')
                  this.$router.push(`/admin/cliente/${res.data.client_id}`)
                })
                .catch(err => { 
                  this.$vs.loading.close()
                  console.error(err)
                  const mensaje_error = err.response.data.errors
                  const array_errors = Object.entries(mensaje_error)
                  for (let i = 0; i < array_errors.length; i++) {
                    this.$vs.notify({
                      title: 'Registro Fallido',
                      text: `${array_errors[i][1][0]}`,
                      iconPack: 'feather',
                      icon: 'icon-x-circle',
                      color: 'warning',
                      time: 6000
                    })
                  }
                })
            })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)
              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
          this.initValues()
        }
      })
    },
    sizeToFit () {
      this.gridApi.sizeColumnsToFit()
    },
    autoSizeAll () {
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds)
    },
    onColumnResized () {
      this.gridApi.resetRowHeights()
    },
    updateListClientsPDN () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarClientsPDN() }.bind(this), 0)
    },
    refrescarClientsPDN () {
      this.$store.dispatch('fetchClientsPDN')
        .then(() => { this.$vs.loading.close() })
    },
    refreshCard (card) {
      this.$store.dispatch('fetchClientsPDN')
      card.removeRefreshAnimation(500)
    },
    addNewData () {
      this.sidebarDataAddClientPDN = {}
      this.toggleDataSidebarAddClientPDN(true)
    },
    toggleDataSidebarAddClientPDN (val = false) {
      this.addNewDataSidebarAddClientPDN = val
    },
    exportarCsvSelected () {
    //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: true,
        fileName: 'ClientesEXT-Seleccionados'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    exportarCsvAll () {
      //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: false,
        fileName: 'ClientesEXT-Todos'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'Todos') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.client_type_filter = { label: 'Todos', value: 'Todos' }
      this.client_status_access_filter = { label: 'Todos', value: 'Todos' }
      this.country_origin_filter2 = {name_country: 'Todos', value: 'Todos'}

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.$store.dispatch('fetchClientsInmigration')
      .catch(err => { 
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err.response.data.error}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })
    if (this.$store.state.countries.length === 0) {
      this.$store.dispatch('fetchCountries').catch(err => { console.error(err) })
    }
  }
}
</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.ag-theme-material .ag-header-cell {
  padding-left: 5px;
  padding-right: 5px;
}
.ag-theme-material .ag-ltr .ag-floating-filter-button {
  margin-left: 0px;
}
.ag-theme-material .ag-cell {
  padding-left: 5px;
  padding-right: 5px;
}
.cell-wrap-text {
    white-space: normal !important;
    line-height:20px!important;
    display: flex;
    align-items: center;
}
.cell-items-center {
  align-items: center;
  display: flex;
  justify-content: center;
}
.ancho-dropdown {
  width: 15rem;
}
</style>